<template>
  <div class='token_bg'>
    <div class='token_desc'>{{$t("message.choose_token_type")}}</div>
    <div class='drop-down-list'>
      <select class='token_input' v-model='curSwapType' @change='changeSwapType()' aria-invalid='false'>
        <option v-for='(token,i) in tokenList' v-bind:value='token.SwapType' :key="i">
          {{getToKenDescByType(token.SwapType)}}
        </option>
      </select>
      <div class='arrow-down'></div>
    </div>
    <!--swap fee desc-->
    <div v-if="isShowFeeTips" class='swap_fee_desc'>*{{swapFeeDesc}}</div>
    <!--token address desc-->
    <div class='token_desc token_address_desc'>
      {{$t("message.enter_address")}}
      <!--<span v-if="getTokenAddressDesc().length" class="token_address_tips">(Do not use the Exchange deposit address)</span>-->
    </div>
    <!--token address input-->
    <input type = 'text' autocomplete='off' autocorrect="off" autocapitalize="off" spellcheck="false" :placeholder='getAddressPlaceholder()' class='token_address_input' :id=addrInputId v-on:input="onSwapAddrChange">
    <!--exchange bnb memo-->
    <template v-if="isExChangeAddr">
      <div class="token_desc token_address_desc">Enter your Exchange memo</div>
      <input type = 'text' autocomplete='off' autocorrect="off" autocapitalize="off" spellcheck="false" placeholder='' class='token_address_input' :id=exMemoInputId>
    </template>
    <fee-notice v-if="serviceFee > 0"
      :token="sourceToken"
      :fee="serviceFee"
    />
  </div>
</template>

<script>
import utils from '../common/utils'
import feeNotice from './feeNotice.vue'
export default {
  name: 'tokenListView',
  components: { feeNotice },
  props: {
    tokenList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      curSwapType: -1, // current swap type
      curTokenType: -1, // current token type
      addrInputId: 'addrInputId',
      isShowFeeTips: false,
      isShowCreateAccount: false,
      createAccountLink: '',
      swapFeeDesc: '',
      isExChangeAddr: false,
      exMemoInputId: 'exChangeMemoInputId'
    }
  },
  computed: {
    serviceFee () {
      return utils.serviceFee(this.curSwapType)
    },
    sourceToken () {
      let swapType = this.curSwapType
      if (utils.checkIsErc20Swap(swapType)) {
        return this.$t('message.erc20_token')
      } else if (utils.checkIsBep2Swap(swapType)) {
        return this.$t('message.bep2_token')
      } else if (utils.checkIsBep20Swap(swapType)) {
        return this.$t('message.bep20_token')
      } else if (utils.checkIsCosMainNetSwap(swapType)) {
        return this.$t('message.main_net_token')
      }
      return ''
    }
  },
  methods: {
    getToKenDescByType (swapType) {
      if (swapType === utils.SwapType.SwapTypeErc20ToBep2) {
        return this.$t('message.token_type_erc20_to_bep2')
      } else if (swapType === utils.SwapType.SwapTypeErc20ToMainNet) {
        return this.$t('message.token_type_erc20_to_native')
      } else if (swapType === utils.SwapType.SwapTypeBep2ToErc20) {
        return this.$t('message.token_type_bep2_to_erc20')
      } else if (swapType === utils.SwapType.SwapTypeBep2ToMainNet) {
        return this.$t('message.token_type_bep2_to_native')
      } else if (swapType === utils.SwapType.SwapTypeMainNetToErc20) {
        return this.$t('message.token_type_native_to_erc20')
      } else if (swapType === utils.SwapType.SwapTypeMainNetToBep2) {
        return this.$t('message.token_type_native_to_bep2')
      } else if (swapType === utils.SwapType.SwapTypeBep20ToMainNet) {
        return this.$t('message.token_type_bep20_to_native')
      } else if (swapType === utils.SwapType.SwapTypeMainNetToBep20) {
        return this.$t('message.token_type_native_to_bep20')
      }
      return ''
    },

    changeSwapType () {
      let swapType = this.curSwapType
      if (utils.checkIsSwapToErc20(swapType)) {
        this.curTokenType = utils.TokenType.TokenTypeErc20
      } else if (utils.checkIsSwapToBep2(swapType)) {
        this.curTokenType = utils.TokenType.TokenTypeBep2
      } else if (utils.checkIsSwapToCosMainNet(swapType)) {
        this.curTokenType = utils.TokenType.TokenTypeCosMainNet
      } else if (utils.checkIsSwapToBep20(swapType)) {
        this.curTokenType = utils.TokenType.TokenTypeBep20
      } else {
        console.log('change to unknown swap type:', swapType)
      }
    },

    getSwapTokenAddress () {
      let addrInput = document.getElementById(this.addrInputId)
      let val = addrInput.value
      return val
    },

    getExchangeMemo () {
      let memoInput = document.getElementById(this.exMemoInputId)
      if (utils.checkIsNotNullObj(memoInput)) {
        let val = memoInput.value
        return val
      }
      return ''
    },

    getAddressPlaceholder () {
      if (this.curTokenType === utils.TokenType.TokenTypeErc20) {
        return 'e.g. 0xcE46FCEC0e6D568B78b90d64803038ceC6B4eDed'
      } else if (this.curTokenType === utils.TokenType.TokenTypeBep20) {
        return 'e.g. 0xcE46FCEC0e6D568B78b90d64803038ceC6B4eDed'
      } else if (this.curTokenType === utils.TokenType.TokenTypeBep2) {
        if (process.env.NODE_ENV === 'production') {
          return 'e.g. bnb1mmxvnhkyqrvd2dpskvsgl8lmft4tnrcs97apr3'
        }
        return 'e.g. tbnb1hvsh83e5ttdl6t3ngmysy0k2l5yxfw23862nx3'
      } else if (this.curTokenType === utils.TokenType.TokenTypeCosMainNet) {
        return 'e.g. initminer'
      }
      return ''
    },

    getSwapInfo () {
      let addr = this.getSwapTokenAddress()
      let exChangeMemo = this.getExchangeMemo()
      let info = {
        swapType: this.curSwapType,
        address: addr,
        exChangeMemo: exChangeMemo
      }
      return info
    },

    initData (val) {
      if (val.length > 0) {
        let fVal = val[0]
        let key = utils.swapTypeKey
        if (fVal.hasOwnProperty(key)) {
          this.curSwapType = fVal[key]
          this.changeSwapType()
        }
      }
    },
    getSwapFeeDesc () {
      // return '*If the number of swap is greater than 500, 50 cos will be charged as a handling fee ' +
      //   'If it is less than 500, 10% of the swap amount will be charged as a handling fee.'
      return this.$t('message.fee_tips')
    },
    onSwapAddrChange (event) {
      let swapAddr = event.target.value
      if ((utils.checkIsBnbExchangeAddr(swapAddr) && utils.checkIsSwapToBep2(this.curSwapType)) || (utils.checkIsCosMainNetExchangeAddr(swapAddr) && utils.checkIsSwapToCosMainNet(this.curSwapType))) {
        this.isExChangeAddr = true
      } else {
        this.isExChangeAddr = false
      }
    }

  },
  watch: {
    curSwapType (val) {
      let addrInput = document.getElementById(this.addrInputId)
      addrInput.value = ''
      // if (!utils.checkIsSwapToCosMainNet(val)) {
      //   this.isShowFeeTips = true
      // } else {
      //   this.isShowFeeTips = false
      // }
      this.swapFeeDesc = ''
      this.isShowFeeTips = false
      for (let token of this.tokenList) {
        if (token[utils.swapTypeKey] === val) {
          if (token.hasOwnProperty(utils.isFreeKey)) {
            let isFree = (token[utils.isFreeKey] === utils.SwapChargeStatus.SwapChargeStatusFree)
            if (!isFree) {
              this.isShowFeeTips = true
              if (token.hasOwnProperty(utils.feeDescKey)) {
                this.swapFeeDesc = token[utils.feeDescKey]
              }
            }
          }
          break
        }
      }
      let isSwapToMainNet = utils.checkIsSwapToCosMainNet(val)
      let isSwapToBep2 = utils.checkIsSwapToBep2(val)
      let isDev = utils.checkIsDev()
      if (isSwapToMainNet || isSwapToBep2) {
        this.isShowCreateAccount = true
        if (isSwapToMainNet) {
          this.createAccountLink = isDev ? 'http://qa.cos.tv' : 'https://cos.tv'
        } else {
          this.createAccountLink = isDev ? 'https://testnet.binance.org/en/create' : 'https://www.binance.org/en/create'
        }
      } else {
        this.isShowCreateAccount = false
        this.createAccountLink = ''
      }

      this.isExChangeAddr = false
    },
    tokenList () {
      this.initData(this.tokenList)
    }
  },
  created () {
    this.initData(this.tokenList)
  }
}

</script>

<style scoped>
  .token_bg {
    width: 50%;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    justify-items: left;
    margin-bottom: -30px;
  }

  .swap_fee_desc {
    margin-top: 5px;
    color: #141414;
    width: 100%;
    font-size: 12px;
    word-wrap: break-word;
    word-break: break-word;
  }

  .token_desc {
    color: #141414;
    font-weight: 600;
    width: 100%;
    font-size: 14px;
    word-wrap: break-word;
    word-break: break-word;
  }

  .drop-down-list {
    display: flex;
    display: -ms-flex;
    flex-direction: row;
    align-items: center;
  }
  .token_input {
    margin-top: 5px;
    width: 100%;
    height: 38px;
    background-color: white;
    appearance:none;
    -moz-appearance:none;
    -webkit-appearance:none;
    padding-left: 10px;
    box-sizing: border-box;
  }

  .arrow-down {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #bfbfbf;
    margin-left: -15px;
    margin-top: 4px;
  }

  .token_address_desc {
    margin-top: 30px;
  }

  .token_address_tips {
    color: rgb(220, 53, 69);
  }

  .token_address_input {
    margin-top: 5px;
    width: 100%;
    height: 36px;
    border-radius: 4px;
    border: 1px solid rgb(166, 166, 166);
    outline: none;
    box-sizing: border-box;
    padding-left: 10px;
  }

  .create_account_tips {
    color: #6a6a6a;
    text-decoration: underline;
    font-size: 14px;
    margin-top: 20px;
    text-align: right;
  }

  @media (max-width: 768px) {
    .token_bg {
      width: 80%;
    }
  }
</style>
